export default __webpack_public_path__ + "assets/images/15f118c6a221026221e8492ac08fafed.svg";